import { render, staticRenderFns } from "./MenuPopup.vue?vue&type=template&id=02b3107e"
import script from "./MenuPopup.vue?vue&type=script&lang=ts"
export * from "./MenuPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports